import { observable, action, computed, makeObservable } from 'mobx'

class ListingTypeStore {
  @observable current = null

  listingTypes = {
    rentals: {
      title: 'For Rent',
      baseUrl: '/for-rent',
      searchUrl: '/search_rentals',
      countResultsUrl: '/api/oe/search_rentals',
      homeUrl: '/rentals',
      searchListingsUrl: '/api/oe/listings/rentals/search',
      mapSearchUrl: '/api/oe/listings/rentals/map_search',
      trendingUrl: '/api/oe/listings/rentals/trending'
    },
    sales: {
      title: 'For Sale',
      baseUrl: '/for-sale',
      searchUrl: '/search_sales',
      countResultsUrl: '/api/oe/search_sales',
      homeUrl: '/',
      searchListingsUrl: '/api/oe/listings/sales/search',
      mapSearchUrl: '/api/oe/listings/sales/map_search',
      trendingUrl: '/api/oe/listings/sales/trending'
    }
  }

  constructor() {
    makeObservable(this)
  }

  @action('[ListingTypeStore] Set initial state')
  setInitialState({ initialState }) {
    this.current = initialState.ListingTypeStore.current
  }

  @action('[ListingTypeStore] Set current listing type')
  setCurrent = value => {
    this.current = value
  }

  @computed
  get currentName() {
    const currentListingType = this.listingTypes[this.current]
    return currentListingType ? currentListingType.title : ''
  }
}

export default ListingTypeStore
